import { Create, Datagrid, Edit, List, NumberInput, SelectArrayInput, SelectInput, SimpleForm, TextField, TextInput, useRecordContext, ReferenceArrayInput, useNavigate, Button } from "react-admin"

export const DoctorList = () => (
    <List sort={{ field: "personal.fio", order: 'ASC'}} perPage={25}>
        <Datagrid rowClick="edit">
            <TextField source="personal.fio" label="ФИО" />
            <TextField source="personal.email" label="email" />
        </Datagrid>
    </List>
);

const DoctorTitle = () => {
    const record = useRecordContext();
    return <span>{record ? `Врач ${record.personal.fio}` : "Врач"}</span>;
};

const ViewSchedulesButton = () => {
  const record = useRecordContext();
  const navigate = useNavigate();

  if (!record?._id) return null;

  const handleClick = () => {
    localStorage.setItem('currentDoctorId', record._id);
    localStorage.setItem('currentDoctorFio', record.personal.fio);
    navigate('/schedules');
  };

  return (
    <Button
      label="Расписания"
      onClick={handleClick}
      variant="text"
    />
  );
};

export const DoctorEdit = () => (
    <Edit title={<DoctorTitle />}>
        <SimpleForm>
            <TextInput source="personal.email" label="Email" fullWidth disabled/>
            <TextInput source="personal.fio" label="ФИО" fullWidth required/>
            <NumberInput source="personal.experience" label="Опыт работы (лет)" fullWidth required/>
            <TextInput source="personal.phone" label="Телефон" fullWidth required/>
            <ReferenceArrayInput source="personal.speciality_ids"
                reference="specialities"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectArrayInput label="Специальности"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput source="personal.languages"
                reference="languages"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectArrayInput label="Языки"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput source="personal.consultation_ids"
                reference="consultation_types"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectArrayInput label="Типы консультаций"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <TextInput source="professional.education" label="Образование" required/>
            <ReferenceArrayInput source="professional.category_id"
                reference="doctor_categories"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectInput label="Категория"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput source="professional.degree_id"
                reference="doctor_degrees"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectInput label="Научная степень"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <TextInput source="professional.quality_up" label="О себе" multiline fullWidth required/>
            <ViewSchedulesButton>
            </ViewSchedulesButton>
        </SimpleForm>
    </Edit>
);

export const DoctorCreate = () => (
    <Create>
        <SimpleForm>
            <TextInput source="personal.fio" label="ФИО" fullWidth required/>
            <TextInput source="personal.email" label="Email" fullWidth required/>
            <TextInput source="personal.phone" label="Телефон" fullWidth required/>
            <NumberInput source="personal.experience" label="Опыт работы (лет)" fullWidth required/>
            <ReferenceArrayInput source="personal.speciality_ids"
                reference="specialities"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectArrayInput label="Специальности"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput source="personal.languages"
                reference="languages"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectArrayInput label="Языки"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput source="personal.consultation_ids"
                reference="consultation_types"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectArrayInput label="Типы консультаций"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>

            <TextInput source="professional.education" label="Образование" required/>
            <ReferenceArrayInput source="professional.category_id"
                reference="doctor_categories"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectInput label="Категория"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <ReferenceArrayInput source="professional.degree_id"
                reference="doctor_degrees"
                perPage={100}
                sort={{ field: 'name', order: 'ASC' }}
            >
                <SelectInput label="Научная степень"
                    optionText="name"
                    optionValue="id"
                    fullWidth
                    required
                />
            </ReferenceArrayInput>
            <TextInput source="professional.quality_up" label="О себе" multiline fullWidth required/>

        </SimpleForm>
    </Create>
);